import { APP_HEADER_STICKY_TOP_SIDEBAR_CLASS } from '@/components/layout/app-header-sticky-top';
import { DETAIL_SIDEBAR_W_CLASS } from '@/lib/ui/layout';
import { cn } from '@/lib/ui/utils';

/** Two-column row under the proposal detail header (matches loaded + skeleton). */
export const PROPOSAL_DETAIL_ROW_CLASS = 'flex min-w-0 gap-4' as const;

/** Primary column: flex child + overflow clip (sticky rail stays a sibling so `sticky` still works). */
export const PROPOSAL_DETAIL_MAIN_COLUMN_CLASS =
  'flex min-w-0 flex-1 flex-col gap-4 overflow-hidden' as const;

/** Desktop funding + outcomes rail — single `className` to avoid fixture/live drift. */
export const PROPOSAL_DETAIL_RIGHT_RAIL_CLASS: string = cn(
  APP_HEADER_STICKY_TOP_SIDEBAR_CLASS,
  DETAIL_SIDEBAR_W_CLASS,
  'sticky hidden min-h-fit shrink-0 self-start @min-[1024px]/proposal-detail:flex @min-[1024px]/proposal-detail:flex-col @min-[1024px]/proposal-detail:gap-4',
);
